import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

export interface TestdatenblattSavedViewFilters {
  query: string | null;
  author: string | null;
  tags: string[] | null;
}

const EMPTY_FILTERS: TestdatenblattSavedViewFilters = { query: null, author: null, tags: null };

export function parseTestdatenblattSavedViewFilters(filtersJson: string | null): TestdatenblattSavedViewFilters {
  const filters = parseSavedViewFilters(filtersJson, EMPTY_FILTERS);
  const tags: unknown = filters.tags;
  return {
    ...filters,
    tags: Array.isArray(tags) ? tags.filter((tag): tag is string => typeof tag === 'string') : null,
  };
}

export function buildTestdatenblattSavedViewFiltersJson(filters: TestdatenblattSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}
